module.exports = __webpack_public_path__ + "img/mitnehmenlogo.ab1f5123.jpg";